import { useRef } from 'react';
import isEqual from 'lodash/isEqual';

export default <T>(value: T) => {
  const ref = useRef<T | undefined>(undefined);

  if (!isEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
};
